async function gzip(string: string): Promise<Uint8Array<ArrayBuffer>> {
    const stream = new Blob([string]).stream().pipeThrough(new CompressionStream("gzip"));
    const arrayBuffer = await new Response(stream).arrayBuffer();
    return new Uint8Array(arrayBuffer);
}

export default async function sendLogs(body: string, accessToken: string, logCollectorUrl: string) {
    const request = {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Content-Encoding": "gzip",
            Authorization: `Bearer ${accessToken}`,
        },
        body: await gzip(body),
    };

    try {
        await fetch(logCollectorUrl, {
            ...request,
            keepalive: true,
        });
    } catch {
        await fetch(logCollectorUrl, request);
    }
}
